import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LunchDealBanner = () => {
  const { t } = useLanguage();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Duplicate text for infinite scroll effect
  const bannerText = `⭐ ${t('hero.ribbon')} ⭐`;
  const repeatedText = Array(6).fill(bannerText).join('   •   ');

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-40 bg-hanse-gold cursor-pointer overflow-hidden"
      onClick={() => scrollToSection('#mittagessen')}
      data-testid="lunch-deal-banner"
    >
      <motion.div
        className="flex whitespace-nowrap py-3"
        animate={{ x: [0, -1000] }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 20,
            ease: "linear",
          },
        }}
      >
        <span className="text-hanse-dark font-semibold text-sm md:text-base flex items-center gap-2 px-4">
          {repeatedText}
          <ArrowRight className="w-4 h-4 inline" />
          {repeatedText}
          <ArrowRight className="w-4 h-4 inline" />
        </span>
      </motion.div>
    </div>
  );
};

export default LunchDealBanner;
